<template>
    <span class="PersonEditor">
        <div>
            <b-form @submit="Save">
                <b-row>
                    <b-col>
                        <h3>Name</h3>
                        <div class="form-group">
                            <label>First Name:</label>
                            <input class="form-control" v-model="UpdatedPerson.FirstName" required />
                        </div>
                        <div class="form-group">
                            <label>AKA:</label>
                            <input class="form-control" v-model="UpdatedPerson.AKA" />
                        </div>
                        <div class="form-group">
                            <label>Middle Name:</label>
                            <input class="form-control" v-model="UpdatedPerson.MiddleName" />
                        </div>
                        <div class="form-group">
                            <label>Last Name:</label>
                            <input class="form-control" v-model="UpdatedPerson.LastName" required />
                        </div>
                        <div class="form-group">
                            <label>Suffix:</label>
                            <input class="form-control" v-model="UpdatedPerson.Suffix" />
                        </div>
                    </b-col>
                    <b-col cols="6">
                        <h3>Outside Systems</h3>
                        <div>
                            <label>Welligent Provider ID:</label>
                            <input class="form-control" v-model="UpdatedPerson.WelligentProviderID" />
                        </div>
                        <div>
                            <label>Avatar Name:</label>
                            <input class="form-control" v-model="UpdatedPerson.AvatarName" />
                        </div>
                        <div>
                            <label>San Bernardino Provider ID:</label>
                            <input class="form-control" v-model="UpdatedPerson.SanBernardinoProviderID" />
                        </div>
                        <h3>Professional Details</h3>
                        <div>
                            <label>License Number:</label>
                            <input class="form-control" v-model="UpdatedPerson.LicenseNumber" />
                        </div>
                        <div>
                            <label>License Type:</label>
                            <select class="form-control" v-model="UpdatedPerson.LicenseType">
                                <option value=""></option>
                                <option value="AMFT">AMFT</option>
                                <option value="ASW">ASW</option>
                                <option value="APCC">APCC</option>
                                <option value="LPCC">LPCC</option>
                                <option value="LCSW">LCSW</option>
                                <option value="LMFT">LMFT</option>
                                <option value="Ph.D.">Ph.D.</option>
                                <option value="MFT Trainee">MFT Trainee</option>
                                <option value="MFT Intern">MSW Intern</option>
                                <option value="PCC Tainee">PCC Trainee</option>
                            </select>
                        </div>
                        <div>
                            <label>Professional Title:</label>
                            <select class="form-control" v-model="UpdatedPerson.ProfessionalTitle">
                                <option value=""></option>
                                <option value="Registered Associate Marriage and Family Therapist">Registered Associate Marriage and Family Therapist</option>
                                <option value="Registered Associate Clinical Social Worker">Registered Associate Clinical Social Worker</option>
                                <option value="Registered Associate Professional Clinical Counselor">Registered Associate Professional Clinical Counselor</option>
                                <option value="Licensed Professional Clinical Counselor">Licensed Professional Clinical Counselor</option>
                                <option value="Licensed Clinical Social Worker">Licensed Clinical Social Worker</option>
                                <option value="Licensed Marriage and Family Therapist">Licensed Marriage and Family Therapist</option>
                                <option value="MFT Trainee">Marriage and Family Therapist Trainee</option>
                                <option value="MFT Intern">Master of Social Work Intern</option>
                                <option value="PCC Tainee">Professional Clinical Counselor Trainee</option>
                            </select>
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <h3>Contact Info</h3>
                        <div class="form-group">
                            <label>Email:</label>
                            <input class="form-control" v-model="UpdatedPerson.Email" />
                        </div>
                        <h3>Phone Numbers <font-awesome-icon :icon="['fa', 'plus']" v-on:click="AddNewPhoneNumber()" class="pointer olive-green-text" /> </h3>

                        <div v-for="(phoneNumber, phoneIndex) in UpdatedPerson.PhoneNumbers">
                            <p class="bold">Phone #{{ phoneIndex + 1 }}: <font-awesome-icon :icon="['fa', 'trash-alt']" v-on:click="DeletePhoneNumber(phoneIndex)" class="pointer red" /></p>
                            <div class="form-group">
                                <label>Phone Number:</label>
                                <input class="form-control" v-model="phoneNumber.PhoneNumber" required />
                            </div>
                            <div class="form-group">
                                <label>Type:</label>
                                <select class="form-control" v-model="phoneNumber.PhoneType" required>
                                    <option value="Cell">Cell</option>
                                    <option value="Home">Home</option>
                                    <option value="Work">Work</option>
                                    <option value="Google">Google</option>
                                    <option value="Fax">Fax</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Description:</label>
                                <input class="form-control" v-model="phoneNumber.Description" />
                            </div>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="modal-btn-row" v-if="ControlButtons">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="success" type="submit">
                            SAVE
                        </b-button>
                    </div>
                </b-row>
            </b-form>
        </div>
    </span>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
    library.add(faTrashAlt);
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import NewDocument from "../RecordComponents/NewDocument.vue";
    import CaseFile from "../RecordComponents/CaseFile.vue";

    import { EventBus } from '../../../services/event-bus.js';

    export default {
        props: [
            "EditMode",//bool
            "DOBRequired",//bool
            "GlobalUpdate",//bool
            "DispatchOnSuccess",//string[]
            "ExistingPerson",//Person.cs object
            "Inline",//bool
            "EndPoint",//string
            "ControlButtons",
            "IncludeParentCharting",//bool
            "ParentId",//string
            "SubProgramId",//string
            "PersonLabelClass",//string
            "IncludePnwParentTracking",//bool
            "IncludePnwFamilyTracking",//bool
            "IncludePnwBabysitterTracking",//bool
            "ChartId",
            "HidePersonalInfo",//bool
            "EmployeeRecord", //Employee.cs object
            "DispatchOnSuccess"
        ],
        data: function () {
            return {
                UpdatedPerson: {
                    Id: "",
                    FirstName: "",
                    AKA: "",
                    MiddleName: "",
                    LastName: "",
                    Suffix: "",
                    DOB: "",
                    SSN: "",
                    SexID: "",
                    RaceID: "",
                    EthnicityID: "",
                    Email: "",
                    PhoneNumbers: [],
                    DriverLicenseExpirationDate: "",
                    CPRExpirationDate: "",
                    FirstAidExpirationDate: "",
                    HIVDate: "",
                    CarInsuranceExpirationDate: "",
                    FluShotDate: "",
                    PertussisDate: "",
                    TBVaccinationDate: "",
                    BC16Obtained: "",
                    BC18Obtained: "",
                    FingerPrintsObtained: "",
                    PolicyAgreementSignedDate: "",
                    FingerPrintNoticeDate: "",
                    BCCUClearedDate: "",
                    BCCUSent: "",
                    WelligentProviderID: "",
                    AvatarName: "",
                    SanBernardinoProviderID: "",
                    LicenseNumber: "",
                    LicenseType: "",
                    ProfessionalTitle: ""
                },
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y',
                    required: false  
                }
                
            };
        },
        methods: {
            GetUpdatedPerson: function() {
                return this.UpdatedPerson;
            },
            ImportExistingPerson() {
                let vm = this;
                if (this.ExistingPerson) {
                    this.UpdatedPerson.Id = this.ExistingPerson.Id
                    this.UpdatedPerson.FirstName = this.ExistingPerson.FirstName;
                    this.UpdatedPerson.AKA = this.ExistingPerson.AKA;
                    this.UpdatedPerson.MiddleName = this.ExistingPerson.MiddleName;
                    this.UpdatedPerson.LastName = this.ExistingPerson.LastName;
                    this.UpdatedPerson.Suffix = this.ExistingPerson.Suffix;
                    this.UpdatedPerson.DOB = this.ExistingPerson.DOB;
                    this.UpdatedPerson.SSN = this.ExistingPerson.SSN;
                    this.UpdatedPerson.SexID = this.ExistingPerson.SexID;
                    this.UpdatedPerson.RaceID = this.ExistingPerson.RaceID;
                    this.UpdatedPerson.EthnicityID = this.ExistingPerson.EthnicityID;
                    this.UpdatedPerson.Email = this.ExistingPerson.Email;
                    this.UpdatedPerson.DriverLicenseExpirationDate = this.ExistingPerson.DriverLicenseExpirationDate;
                    this.UpdatedPerson.CPRExpirationDate = this.ExistingPerson.CPRExpirationDate;
                    this.UpdatedPerson.FirstAidExpirationDate = this.ExistingPerson.FirstAidExpirationDate;
                    this.UpdatedPerson.HIVDate = this.ExistingPerson.HIVDate;
                    this.UpdatedPerson.CarInsuranceExpirationDate = this.ExistingPerson.CarInsuranceExpirationDate;
                    this.UpdatedPerson.FluShotDate = this.ExistingPerson.FluShotDate;
                    this.UpdatedPerson.PertussisDate = this.ExistingPerson.PertussisDate;
                    this.UpdatedPerson.TBVaccinationDate = this.ExistingPerson.TBVaccinationDate;
                    this.UpdatedPerson.BC16Obtained = this.ExistingPerson.BC16Obtained;
                    this.UpdatedPerson.BC18Obtained = this.ExistingPerson.BC18Obtained;
                    this.UpdatedPerson.FingerPrintsObtained = this.ExistingPerson.FingerPrintsObtained;
                    this.UpdatedPerson.PolicyAgreementSignedDate = this.ExistingPerson.PolicyAgreementSignedDate;
                    this.UpdatedPerson.FingerPrintNoticeDate = this.ExistingPerson.FingerPrintNoticeDate;
                    this.UpdatedPerson.BCCUClearedDate = this.ExistingPerson.BCCUClearedDate;
                    this.UpdatedPerson.BCCUSent = this.ExistingPerson.BCCUSent;
                    
                    this.UpdatedPerson.AvatarName = this.ExistingPerson.AvatarProviderName;
                    this.UpdatedPerson.SanBernardinoProviderID = this.ExistingPerson.SanBernardinoProviderID;
                    if (this.EmployeeRecord != undefined) {
                        this.UpdatedPerson.WelligentProviderID = this.EmployeeRecord.WelligentID;
                    }
                    this.UpdatedPerson.LicenseNumber = this.ExistingPerson.LicenseNumber;
                    this.UpdatedPerson.LicenseType = this.ExistingPerson.LicenseType;
                    this.UpdatedPerson.ProfessionalTitle = this.ExistingPerson.ProfessionalTitle;
                    //import phone numbers

                    this.ExistingPerson.PhoneNumbers.forEach(function (item) {
                        if (item.EndDate == null) {
                            vm.UpdatedPerson.PhoneNumbers.push({
                                MembershipID: item.Id,
                                PhoneNumber: item.PhoneNumber.FormattedPhoneNumber,
                                PhoneType: item.PhoneNumber.PhoneType,
                                Description: item.PhoneNumber.Description
                            });
                        }
                    });
                }

            },
            ShowEditModal() {
                this.UpdatedPerson.PhoneNumbers = [];
                let vm = this;

                if (this.ExistingPerson) {
                    this.UpdatedPerson.Id = this.ExistingPerson.Id
                    this.UpdatedPerson.FirstName = this.ExistingPerson.FirstName;
                    this.UpdatedPerson.AKA = this.ExistingPerson.AKA;
                    this.UpdatedPerson.MiddleName = this.ExistingPerson.MiddleName;
                    this.UpdatedPerson.LastName = this.ExistingPerson.LastName;
                    this.UpdatedPerson.Suffix = this.ExistingPerson.Suffix;
                    this.UpdatedPerson.DOB = this.ExistingPerson.DOB;
                    this.UpdatedPerson.SSN = this.ExistingPerson.SSN;
                    this.UpdatedPerson.SexID = this.ExistingPerson.SexID;
                    this.UpdatedPerson.RaceID = this.ExistingPerson.RaceID;
                    this.UpdatedPerson.EthnicityID = this.ExistingPerson.EthnicityID;
                    this.UpdatedPerson.Email = this.ExistingPerson.Email;
                    this.UpdatedPerson.DriverLicenseExpirationDate = this.ExistingPerson.DriverLicenseExpirationDate;
                    this.UpdatedPerson.CPRExpirationDate = this.ExistingPerson.CPRExpirationDate;
                    this.UpdatedPerson.FirstAidExpirationDate = this.ExistingPerson.FirstAidExpirationDate;
                    this.UpdatedPerson.HIVDate = this.ExistingPerson.HIVDate;
                    this.UpdatedPerson.CarInsuranceExpirationDate = this.ExistingPerson.CarInsuranceExpirationDate;
                    this.UpdatedPerson.FluShotDate = this.ExistingPerson.FluShotDate;
                    this.UpdatedPerson.PertussisDate = this.ExistingPerson.PertussisDate;
                    this.UpdatedPerson.TBVaccinationDate = this.ExistingPerson.TBVaccinationDate;
                    this.UpdatedPerson.BC16Obtained = this.ExistingPerson.BC16Obtained;
                    this.UpdatedPerson.BC18Obtained = this.ExistingPerson.BC18Obtained;
                    this.UpdatedPerson.FingerPrintsObtained = this.ExistingPerson.FingerPrintsObtained;
                    this.UpdatedPerson.PolicyAgreementSignedDate = this.ExistingPerson.PolicyAgreementSignedDate;
                    this.UpdatedPerson.FingerPrintNoticeDate = this.ExistingPerson.FingerPrintNoticeDate;
                    this.UpdatedPerson.BCCUClearedDate = this.ExistingPerson.BCCUClearedDate;
                    this.UpdatedPerson.BCCUSent = this.ExistingPerson.BCCUSent;
                    
                    this.UpdatedPerson.AvatarName = this.ExistingPerson.AvatarProviderName;
                    this.UpdatedPerson.SanBernardinoProviderID = this.ExistingPerson.SanBernardinoProviderID;
                    if (this.EmployeeRecord != undefined) {
                        this.UpdatedPerson.WelligentProviderID = this.EmployeeRecord.WelligentID;
                    }
                    this.UpdatedPerson.LicenseNumber = this.ExistingPerson.LicenseNumber;
                    this.UpdatedPerson.LicenseType = this.ExistingPerson.LicenseType;
                    this.UpdatedPerson.ProfessionalTitle = this.ExistingPerson.ProfessionalTitle;
                    //import phone numbers

                    this.ExistingPerson.PhoneNumbers.forEach(function (item) {
                        if (item.EndDate == null) {
                            vm.UpdatedPerson.PhoneNumbers.push({
                                MembershipID: item.Id,
                                PhoneNumber: item.PhoneNumber.FormattedPhoneNumber,
                                PhoneType: item.PhoneNumber.PhoneType,
                                Description: item.PhoneNumber.Description
                            });
                        }
                    });
                }

                if (this.Inline == false) {
                    this.$refs['component-modal'].show();
                }
            },
            Cancel() {
                this.$refs['component-modal'].hide();
            },
            Save(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Core/Person/UpdateFullPersonRecord", this.UpdatedPerson, this.SaveSuccess, () => { }, true);
            },
            SaveSuccess(response) {
                if (!this.Inline) {
                    this.$refs['component-modal'].hide();
                }
                //Perform Global Updates
                if (this.GlobalUpdate) {
                    this.$GlobalUpdate.ExecuteGlobalUpdate(this.ChartId);
                }
                //Fire Events if present
                if (this.DispatchOnSuccess != null) {
                    this.DispatchOnSuccess.forEach(function (item) {
                        EventBus.$emit(item);
                    });
                }
                alert("Saved Successfully.");
            },
            AddNewPhoneNumber() {
                this.UpdatedPerson.PhoneNumbers.push({
                    MembershipID: null,
                    PhoneNumber: "",
                    PhoneType: "",
                    Description: ""
                });
            },
            DeletePhoneNumber(phoneIndex) {
                this.UpdatedPerson.PhoneNumbers.splice(phoneIndex, 1);
            },
            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null || value == '')
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
            NewDocument,
            CaseFile
        },
        computed: {
            SexOptions: function () {
                return this.$store.state.Options.Sexes;
            },
            RaceOptions: function () {
                return this.$store.state.Options.Races;
            },
            EthnicityOptions: function () {
                return this.$store.state.Options.Ethnicities;
            },
            TargetPersonPhoneNumbers: function () {
                let phoneNumbers = [];
                if (this.ExistingPerson) {
                    this.ExistingPerson.PhoneNumbers.forEach(function (item) {
                        if (item.EndDate == null) {
                            phoneNumbers.push({
                                MembershipID: item.Id,
                                PhoneNumber: item.PhoneNumber.FormattedPhoneNumber,
                                PhoneType: item.PhoneNumber.PhoneType,
                                Description: item.PhoneNumber.Description
                            });
                        }
                    });
                }
                return phoneNumbers;

            },
            ParentFormMemberships: function () {
                let subProgram = this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgram"](this.SubProgramId);
                return subProgram.FormMemberships.filter(fm => fm.ChartType == "FosterResourceParent");
            }
        },
        mounted() {
            this.ImportExistingPerson();
        }
    }
</script>

<style scoped>
</style>